import axios from "axios";
import { useToast } from "../context/ToastContext";
import { useCallback } from "react";
import { getUrl } from "./helper-function";


export async function sendRequest(
  method: "GET" | "POST" | "PUT" | "DELETE",
  endpoint: string,
  data?: any,
  useAuth: boolean = true,
  timeout: number = 15000
) {

  const url = getUrl();
  const API_BASE_URL = url + "/api/v2";

  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (useAuth) {
    const authToken = localStorage.getItem("authToken");
    if (authToken) {
      headers["Authorization"] = `Bearer ${authToken}`;
    }
  }

  try {
    const response = await axios({
      method,
      url: `${API_BASE_URL}${endpoint}`,
      data,
      headers,
      withCredentials: true,
      timeout,
    });

    return response.data;
  } catch (error: any) {
    if (error.code === "ECONNABORTED") {
      throw new Error("TIMEOUT");
    }

    if (error.response?.status === 401 && useAuth) {
      // alert("Your session has expired. Please log in again.");
      localStorage.removeItem("authToken");

      console.log(error.response.data.error)

      console.log(error.response.data.error )
      if (error.response.data.error === "Guest Session Expired")
        window.location.href = "/guests/login";
      else
        window.location.href = "/login";
    }

    // console.log({api: error})
    throw error;
  }
}

interface HandleApiConflictOptions {
  onReload?: () => void;       // optional callback to refresh data
  reloadDelay?: number;        // delay before reload (ms)
}

export const useHandleApiConflict = ({
  onReload,
  reloadDelay = 1500,
}: HandleApiConflictOptions = {}) => {
  const { showToast } = useToast();

  const handleApiConflict = useCallback(
    (error: any, type: "booking" | "order" | "loan" | "leave") => {
      const status = error?.response?.status ?? error.status;

      if (status === 404) {
        showToast(`This ${type} no longer exists. Refreshing data…`, { type: "info" });
        if (onReload) {
          setTimeout(onReload, reloadDelay);
        } else {
          setTimeout(() => window.location.reload(), reloadDelay);
        }
        return true;
      }

      if (status === 409) {
        showToast(`This ${type} was recently updated by another staff. Refreshing data…`, {
          type: "info",
        });
        if (onReload) {
          setTimeout(onReload, reloadDelay);
        } else {
          setTimeout(() => window.location.reload(), reloadDelay);
        }
        return true;
      }

      if (status === 403) {
        showToast(
          `This ${type} can no longer be modified as it has been finalized by another staff.
          Refreshing data…`, { type: "warning", }
        );
        if (onReload) {
          setTimeout(onReload, reloadDelay);
        } else {
          setTimeout(() => window.location.reload(), reloadDelay);
        }
        return true;
      }

      return false; // not a handled conflict
    },
    [onReload, reloadDelay]
  );

  return { handleApiConflict };
};


export const errorMessage = (statusCode: number | undefined): { title: string, msg: string } | null => {

  if (statusCode === 500) {
    return {
      title: "Internal Error",
      msg: "An error occured. Please try again."
    };
  } else if (statusCode === 408 || statusCode === undefined) {
    return {
      title: "Network Error",
      msg: "Request timeout. Please check network connection."
    }
  }
  return null;
}